import {OrdersComponent} from './orders/orders.component';
import {OrderDetailComponent} from './orders/detail/order-detail.component';
import {CanActivateFn, Router, Routes} from "@angular/router";
import {LayoutComponent} from "./layout/layout.component";
import {HomeComponent} from "./home/home.component";
import {SlidesComponent} from "./landing/slides/slides.component";
import {ExhibitionsComponent} from "../front-office/exhibitions/exhibitions.component";
import {ConfiguratorComponent} from "./landing/configurator/configurator.component";
import {CreateFormComponent} from "./landing/slides/create-form/create-form.component";
import {UsersComponent} from "./users/users.component";
import {TableComponent} from "./users/table/table.component";
import {DetailsComponent} from "./users/details/details.component";
import {ContactComponent} from "./users/details/contact/contact.component";
import {ArtworksComponent} from "./artworks/artworks.component";
import {SalesComponent} from "./users/details/sales/sales.component";
import {DetailsComponent as ArtworksDetailsComponent} from './artworks/details/details.component';
import {RenderMode, ServerRoute} from "@angular/ssr";
import {inject} from "@angular/core";
import {AuthenticationService} from "../../services/auth.service";
import {BlogsComponent} from "../front-office/profile";
import {BackofficeMessagesComponent} from "./messages/messages.component";
import {ArtworksTableComponent} from './artworks/table/table.component';

const isAdmin: CanActivateFn = (route, state) => {
  const authService = inject(AuthenticationService);
  const router = inject(Router)
  const token = authService.token();
  if (!token) return router.createUrlTree(['/auth', 'login']);
  const payload = JSON.parse(atob(token.split('.')[1]))
  const isAdmin = !!payload.roles?.find((d: any) => d.role.name === 'ADMIN');
  if(!isAdmin) return router.createUrlTree(['/auth', 'login']);
  return true;
}

export const routes: Routes = [
  {
    path: 'backoffice',
    loadComponent:() => LayoutComponent,
    loadChildren: () => [
      {
        path: '',
        loadComponent: () => HomeComponent
      },
      {
        path: 'users',
        component: UsersComponent,
        children: [
          {
            path: '',
            redirectTo: 'artists',
            pathMatch: 'full',
          },
          {
            path: ':role',
            component: TableComponent
          }
        ]
      },
      {
        path: 'users/:id',
        component: UsersComponent,
        children: [
          {
            path: 'details',
            component: DetailsComponent,
            children: [
              {
                path: '',
                redirectTo: 'profile',
                pathMatch: 'full'
              },
              {
                path: 'profile',
                component: ContactComponent
              },
              {
                path: 'artworks',
                component: ArtworksComponent,
                children: [
                  {
                    path: ':id',
                    component: ArtworksDetailsComponent,
                  }
                ]
              },
              {
                path: 'sales',
                component: SalesComponent
              }
            ]
          }
        ]
      },
      {
        path: 'editorials',
        component: ConfiguratorComponent,
        children: [
          {
            path: '',
            redirectTo: 'slides',
            pathMatch: 'full',
          },
          {
            path: 'slides',
            loadComponent: () => SlidesComponent
          },
          {
            path: 'slides/new',
            loadComponent: () => CreateFormComponent
          },
          {
            path: 'slides/:id',
            loadComponent: () => CreateFormComponent
          },
          {
            path: 'exhibitions',
            loadComponent: () => ExhibitionsComponent
          }
        ]
      },
      {
        path: 'artworks',
        component: ArtworksTableComponent
      },
      {
        path: 'blogs',
        component: BlogsComponent,
      },
      {
        path: 'messages',
        component: BackofficeMessagesComponent,
      },
      {
        path: 'mail-templates',
        loadComponent: () => import('./mailtemplate/mailtemplate.component').then(m => m.MailtemplateComponent)
      },
      {
        path: 'mail-templates/:id',
        loadComponent: () => import('./mailtemplate/form/form.component').then(m => m.EmailTemplateFormComponent)
      },
      {
        path: 'newsletter',
        loadComponent: () => import('./newsletter/newsletter.component').then(m => m.NewsletterComponent)
      },
       {
        path: 'newsletter/:id',
        loadComponent: () => import('./mailtemplate/form/form.component').then(m => m.EmailTemplateFormComponent)
      },
      {
        path: 'orders',
        component: OrdersComponent
      },
      {
        path: 'orders/:orderId',
        component: OrderDetailComponent
      },
      {
        path: 'translations',
        loadComponent: () => import('./translations/translations.component').then(m => m.TranslationsComponent)
      },
      {
        path: 'subscriptions',
        loadComponent: () => import('./subscriptions/subscriptions.component').then(m => m.SubscriptionsComponent)
      }
    ],
    canActivate: [
      isAdmin
    ],
    canActivateChild: [
      isAdmin
    ]
  }
]

export const serverRoutes: ServerRoute[] = [
  {
    path: 'backoffice',
    renderMode: RenderMode.Client
  },
  {
    path: 'backoffice/users',
    renderMode: RenderMode.Client
  },
  {
    path: 'backoffice/users/:role',
    renderMode: RenderMode.Client
  },
  {
    path: 'backoffice/users/:id/details',
    renderMode: RenderMode.Client
  },
  {
    path: 'backoffice/users/:id/details/profile',
    renderMode: RenderMode.Client
  },
  {
    path: 'backoffice/users/:id/details/artworks',
    renderMode: RenderMode.Client
  },
  {
    path: 'backoffice/users/:id/details/artworks/:id',
    renderMode: RenderMode.Client
  },
  {
    path: 'backoffice/users/:id/details/sales',
    renderMode: RenderMode.Client
  },
  {
    path: 'backoffice/editorials',
    renderMode: RenderMode.Client
  },
  {
    path: 'backoffice/editorials/slides',
    renderMode: RenderMode.Client
  },
  {
    path: 'backoffice/editorials/slides/new',
    renderMode: RenderMode.Client
  },
  {
    path: 'backoffice/editorials/slides/:id',
    renderMode: RenderMode.Client
  },
  {
    path: 'backoffice/editorials/exhibitions',
    renderMode: RenderMode.Client
  },
  {
    path: 'backoffice/blogs',
    renderMode: RenderMode.Client
  },
  {
    path: 'backoffice/messages',
    renderMode: RenderMode.Client
  },
  {
    path: 'backoffice/mail-templates',
    renderMode: RenderMode.Client
  },
  {
    path: 'backoffice/mail-templates/:id',
    renderMode: RenderMode.Client
  },
  {
    path: 'backoffice/newsletter',
    renderMode: RenderMode.Client
  },
   {
    path: 'backoffice/newsletter/:id',
    renderMode: RenderMode.Client
  },
  {
    path: 'backoffice/translations',
    renderMode: RenderMode.Client
  },
  {
    path: 'backoffice/orders',
    renderMode: RenderMode.Client
  },
  {
    path: 'backoffice/orders/:orderId',
    renderMode: RenderMode.Client
  },
  {
    path: 'backoffice/subscriptions',
    renderMode: RenderMode.Client
  },
  {
    path: 'backoffice/**',
    renderMode: RenderMode.Client
  }
]
